import React, { useEffect, useState } from "react";
import InputForm from "../../../components/Input/InputForm";
import { Button } from "../../../components/ui/Buttons";
import Dialog from "../../../components/Dialog/Dialog";
import { withStyles } from "@material-ui/core";
import { updateDadosDasa } from "../../../services/ConfiguracoesUnidadeService";

const ModalConfigDasa = ({
  classes,
  open,
  onClose,
  configuracaoUnidade,
  isLoading,
  loadConfiguracaoUnidade,
}) => {
  const [agente, setAgente] = useState({});
;

  const onChange = (event, field) => {
    const value = event?.target?.value ?? event;
    setAgente((prevState) => {
      return {
        ...prevState,
        [field]: value,
      };
    });
  };

  const onSave = async () => {
    try {
      const variables = {
        dadosDasa: { ...agente , status:true}
      }

      const response = await updateDadosDasa(variables)
      if (response?.id) {
        await loadConfiguracaoUnidade()
        onClose()
      }

    } catch (error) {
      console.error(error)
    }
  };

  useEffect(() => {
    if (configuracaoUnidade?.dadosDasa?.id) {
      const dadosDasa = {
        idAgente: configuracaoUnidade?.dadosDasa?.idAgente,
        senha: configuracaoUnidade?.dadosDasa?.senha,
        entidade: configuracaoUnidade?.dadosDasa?.entidade
      }

      setAgente(dadosDasa)
    }
  }, [])

  return (
    <Dialog open={open} classes={{ paper: classes.container }}>
      <div className={classes.title}>Fazer o uso da Api Dasa</div>
      <div className={classes.containerInput}>
        <span>entidade*</span>
        <InputForm
          id="cfg-mda-inp-ent"
          classes={{ input: classes.input }}
          onChange={(e) => onChange(e, "entidade")}
          value={agente.entidade}
        />
      </div>
      <div className={classes.containerInput}>
        <span>idAgente*</span>
        <InputForm
          id="cfg-mda-inp-ida"
          classes={{ input: classes.input }}
          onChange={(e) => onChange(e, "idAgente")}
          value={agente.idAgente}
        />
      </div>

      <div className={classes.containerInput}>
        <span>Senha*</span>
        <InputForm
          id="cfg-mda-inp-sen"
          classes={{ input: classes.input }}
          onChange={(e) => onChange(e, "senha")}
          value={agente.senha}
        />
      </div>

      <div className={classes.contentButtons}>
        <Button id="cfg-mda-btn-can" onClick={onClose} kind={"transparent"}>
          Cancelar
        </Button>
        <Button
          id="cfg-mda-btn-sal"
          width={"208px"}
          onClick={onSave}
          disabled={!agente.idAgente || !agente.senha || isLoading}
        >
          Salvar Credenciais
        </Button>
      </div>
    </Dialog>
  );
};

const styles = {
  container: {
    minWidth: "395px",
    height: "295px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    padding: "32px",
    gap: "8px",
  },
  title: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#26ACA9",
  },
  containerInput: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    color: "#868686",
    fontSize: "12px",
  },
  input: {
    border: "none",
    background: "#F2F2F2",
  },
  contentButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    paddingTop: "16px",
  },
};

export default withStyles(styles)(ModalConfigDasa);
